import React from "react";
import dynamic from "next/dynamic";
const BannerDashboard = dynamic(
  () => import("./BannerDashboard"),
  { ssr: true }
);
import "./BannerSection.css";

export default function BannerSection({ title, title2, description, tags }) {

  const displayTitle = title || "Revolutionize Your";
  const displayTitle2 = title2 || "Software Development";
  const displayDescription = description || "One intelligent workspace to plan, code, test, and deploy your software — powered by AI, driven by results.";
  const displayTags = tags && tags.length > 0 ? tags : ["Custom Software", "Web Applications", "Mobile Apps", "Cloud Solutions"];

  return (
    <section className="bs-section">
      {/* BACKGROUND GLOW */}
      <div className="bs-bg-glow"></div>

      {/* MAIN HEADING — no AOS delay: this is the LCP element, must render immediately */}
      <div className="bs-heading-wrapper">
        <h1 className="bs-main-title">
          {displayTitle} <br />
          <span className="bs-gradient-text">{displayTitle2}</span>
        </h1>
      </div>

      {/* DESCRIPTION */}
      <p className="bs-description">
        {displayDescription}
      </p>

      {/* SERVICES TAGS */}
      <div className="bs-tags-row">
        {displayTags.map((tag, idx) => (
          <span key={idx} className="bs-tag">
            <span className="bs-tag-icon">✦</span> {tag}
          </span>
        ))}
      </div>

      {/* STATS */}
      {/* <div className="bs-stats-row" data-aos="fade-up" data-aos-delay="400">
        <div className="bs-stat-item">
          <div className="bs-stat-number">54K+</div>
          <div className="bs-stat-label">Developers</div>
        </div>
        <div className="bs-stat-divider"></div>
        <div className="bs-stat-item">
          <div className="bs-stat-number">2.4B</div>
          <div className="bs-stat-label">Lines Generated</div>
        </div>
        <div className="bs-stat-divider"></div>
        <div className="bs-stat-item">
          <div className="bs-stat-number">98%</div>
          <div className="bs-stat-label">Satisfaction</div>
        </div>
      </div> */}

      {/* DOWN ARROW */}
      {/* <div className="bs-scroll-arrow-container" data-aos="fade-up" data-aos-delay="500">
        <motion.button 
          className="bs-scroll-arrow" 
          onClick={scrollToDashboard}
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>
        </motion.button>
      </div> */}

      <BannerDashboard />
    </section>
  );
}
